<template>
    <div class="commerce-page">
        <div class="container">
            <div class="page-title" v-if="setup != null">
                <h1>{{ setup.page_titles.commerce_title }}</h1>
            </div>
        </div>
        <commerceFilter v-if="filterCMSparams != null"></commerceFilter>
        <div class="container" v-if="filterCMSparams != null && commerceItemsArr != null && !isMobileChecker">
            <div class="items-controls">
                <commerceFindNum></commerceFindNum>
                <div class="controls">
                    <commerceShorting></commerceShorting>
                    <commerceViewBtns></commerceViewBtns>
                </div>
            </div>
        </div>
        <commerceListTable v-if="!isMobileChecker && filterCMSparams != null && commerceItemsArr != null && commerceListView == 'list'"></commerceListTable>
        <commerceItems v-if="filterCMSparams != null && commerceItemsArr != null"></commerceItems>
        <formPage v-if="filterCMSparams != null"></formPage>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    // import store from '@/store.js'
    import commerceFilter from '@/components/filters/commerce-filter/commerce-filter.vue'
    import commerceItems from '@/components/commerce-page/commerce-items.vue'
    import commerceListTable from '@/components/commerce-page/commerce-list-table.vue'
    import commerceFindNum from '@/components/commerce-page/commerce-find-num.vue'
    import commerceViewBtns from '@/components/commerce-page/commerce-view-btns.vue'
    import commerceShorting from '@/components/filters/commerce-filter/shorting-filter.vue'
    import formPage from '@/components/forms/form-page.vue'
    export default {
        name: 'commerce--page',
        components: {
            commerceFilter,
            commerceItems,
            commerceListTable,
            commerceFindNum,
            commerceViewBtns,
            commerceShorting,
            formPage,
        },
        metaInfo() {
            return {
                title: 'Надежный застройщик "DIAL GROUP" - Коммерческая недвижимость',
                meta: [
                    { name: 'description', content:  'Первичные квартиры комфорт-класса в Алмалинском районе от 24 000 000 тенге. В 10 минутах от MEGA Park. Готовые квартиры в ЖК бизнес-класса в золотом квадрате.'},
                ]
            };
        },
        data () {
            return {
                globalLang: window.GlobalLang, 
            }
        },
        computed: mapGetters({
            setup: 'loadPageSetUp',
            filterCMSparams: 'loadFilterCMSparams',
            commerceItemsArr: 'loadCommerceItems',
            isOpenFilterMobile: 'loadOpenCommerceMobileFilter',
            isMobileChecker: 'loadIsMobileChecker',
            commerceListView: 'loadCommerceListView',
            // aboutPage: 'loadAboutPage',
        }),
        methods: {
        },
        beforeCreate() {
            this.$store.dispatch('getCommerceItems');
            document.body.dataset.page = 'commerce';
        },
        created () {
        },
        mounted() {
        }
    }
</script>

<style lang="scss">
    @import '@/styles/components/commerce-page/commerce-page.scss';
    @import '@/styles/components/commerce-page/respond/commerce-page-respond.scss';
</style>